import React from 'react';
import { Flex, Typography } from 'antd';
import { formatCurrency } from '../../../utils/helpers';
import { loftColors } from '../../../antd/theme';

const { Text } = Typography;

interface FinancialsSummaryProps {
  amountDue?: number;
}

const FinancialsSummary: React.FC<FinancialsSummaryProps> = ({
  amountDue = 0,
}) => {
  return (
    <div
      style={{
        backgroundColor: loftColors.grays[7],
        border: `1px solid ${loftColors.grays[25]}`,
        borderRadius: 4,
        padding: 16,
        marginBottom: 16,
      }}
    >
      <Flex justify="space-between" align="center">
        <Text strong style={{ fontSize: 16 }}>
          Account History
        </Text>
        <Flex vertical align="flex-end">
          <Text style={{ fontSize: 12, color: loftColors.grays[75] }}>
            Total Amount Due
          </Text>
          <Text strong style={{ fontSize: 18 }}>
            {formatCurrency(amountDue.toFixed(2), 'USD')}
          </Text>
        </Flex>
      </Flex>
    </div>
  );
};

export default FinancialsSummary;
